<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
  <div>
    <router-link :to="{name: 'OrganizationView', params: {id: news.textParams[0]}}"
    >{{news.textParams[1]}}</router-link>
    {{$t('news.template.proposal.publishByOrg.p1')}}
    "<router-link :to="{name: 'ProposalView', params: {id: news.textParams[3]}}">
    {{news.textParams[4]}}
    </router-link>"
    {{$t('news.template.proposal.publishByOrg.p2')}}
    <router-link :to="{name: 'forum', params: {id: news.textParams[5]}}"
    >{{news.textParams[6]}}</router-link>
  </div>
</template>
